import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ElementoBusquedaService {
  constructor(private httpClient: HttpClient) {}

  modificarHashtag(
    elementoId: number,
    preguntaId: number,
    palabrasClave: string
  ) {
    const formData = new FormData();
    formData.append('palabrasClave', palabrasClave.trim());
    formData.append('preguntaId', preguntaId.toString());

    return this.httpClient.put(
      encodeURI(`${environment.apiURL}/hashtags/${elementoId}`),
      formData
    );
  }
}
